import React, { createContext, useContext, useEffect, useState } from 'react';
import pb from '../lib/pocketbase';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(pb.authStore.model);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Subscribe to auth state changes
        const unsubscribe = pb.authStore.onChange((token, model) => {
            setUser(model);
        });

        setLoading(false);

        return () => {
            unsubscribe();
        };
    }, []);

    const login = async (email, password) => {
        try {
            await pb.collection('users').authWithPassword(email, password);
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const logout = () => {
        pb.authStore.clear();
    };

    const register = async (email, password) => {
        try {
            await pb.collection('users').create({
                email,
                password,
                passwordConfirm: password,
            });
            await login(email, password);
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, register, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
